import uniq from 'lodash/uniq'
import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'
import { CMDB_CONTACTS_URL, CONTACTS_URL } from 'src/constants/urls'

const contacts = createReducer(
    {
        byId: {},
        values: [],
        searchResults: [],
        loading: false,
        modalOpen: false,
        errors: {},
        cmdbImportContacts: [],
    },
    {
        [actions.GET_CMDB_CONTACTS]: (state) => {
            return {
                ...state,
                loading: true,
                searchResults: [],
            }
        },
        [actions.GET_CMDB_CONTACTS_SUCCESS]: (state, action) => {
            const { results } = action.payload.data

            const searchResults = results.map((contact) => contact.id)
            return {
                ...state,
                byId: {
                    ...results.reduce(
                        (agg, contact) => ({
                            ...agg,
                            [contact.id]: contact,
                        }),
                        state.byId
                    ),
                },
                values: uniq([...state.values, ...searchResults]),
                searchResults,
                loading: false,
            }
        },
        [actions.GET_CMDB_CONTACTS_ERROR]: (state, action) => {
            return { ...state, loading: false }
        },
        [actions.TOGGLE_CONTACT_IMPORT]: (state, action) => {
            const { contactId } = action.payload
            const { byId } = state
            return {
                ...state,
                byId: {
                    ...byId,
                    [contactId]: {
                        ...byId[contactId],
                        selected: !byId[contactId].selected,
                    },
                },
            }
        },
        [actions.TOGGLE_ALL_CONTACTS_IMPORT]: (state, action) => {
            const { checked } = action.payload
            const { byId, cmdbImportContacts } = state
            for (let i = 0; i < cmdbImportContacts.length; i++) {
                byId[cmdbImportContacts[i]].selected = checked
            }
            return {
                ...state,
                byId: { ...byId },
            }
        },
        [actions.SAVE_CMDB_CONTACT_SUCCESS]: (state, action) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.contactId]: {
                        ...state.byId[action.contactId],
                        exists: true,
                    },
                },
            }
        },
    }
)

export const getCmdbContacts = (query, extra = '') => {
    const url = `${CMDB_CONTACTS_URL}${query ? query + '/' : ''}${extra}`
    return {
        type: actions.API,
        method: 'get',
        payload: {
            url,
            start: () => ({ type: actions.GET_CMDB_CONTACTS }),
            success: (payload) => ({
                type: actions.GET_CMDB_CONTACTS_SUCCESS,
                payload,
            }),
            error: (error) => ({
                type: actions.GET_CMDB_CONTACTS_ERROR,
                error,
            }),
        },
        debounce: {
            key: 'searchCmdbContacts',
            wait: 500,
        },
    }
}

export const importContact = (contactId) => (dispatch, getState) => {
    const contact = getContactById(getState(), contactId)
    dispatch({
        type: actions.API,
        method: contact.exists ? 'put' : 'post',
        data: {
            id: contact.id,
            user: {
                id: contact.id,
                first_name: contact.firstName,
                last_name: contact.lastName,
                email: contact.email || '',
                username: contact.userName,
            },
        },
        payload: {
            url: contact.exists
                ? `${CONTACTS_URL}${contactId ? contactId + '/' : ''}`
                : CONTACTS_URL,
            start: () => ({ type: actions.SAVE_CMDB_CONTACT }),
            success: (payload) => ({
                type: actions.SAVE_CMDB_CONTACT_SUCCESS,
                payload,
                contactId,
            }),
            error: (error) => ({
                type: actions.SAVE_CMDB_CONTACT_ERROR,
                error,
            }),
        },
    })
}

export const toggleContactForImport = (contactId) => ({
    type: actions.TOGGLE_CONTACT_IMPORT,
    payload: { contactId },
})

export const toggleAllContactsForImport = (checked) => ({
    type: actions.TOGGLE_ALL_CONTACTS_IMPORT,
    payload: {
        checked,
    },
})

export const getContactById = (state, id) => state.cmdb.contacts.byId[id]

export const getContactsSearchResults = (state) =>
    state.cmdb.contacts.searchResults.map((id) => state.cmdb.contacts.byId[id])

export const getContactsForImport = (state) =>
    state.cmdb.contacts.cmdbImportContacts.map(
        (id) => state.cmdb.contacts.byId[id]
    )

export default contacts
